<template>
    <div>
        <base-crud
            crudName="Feriados"
            newText="Novo Feriado"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint='endPoint'
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :dataForm="dataForm"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                table: 'holidaysTable',
                // pages: [],
                // url: '',
                columns: [
                  'id',
                  'name',
                  'date',
                  'type',
                  'city',
                  'state',
                  'actions'
                ],
                tableData: [
                  'id',
                  'name',
                  'date',
                  'type',
                  'city',
                  'state'
                ],
                options: {
                    sortable: ['id', 'name', 'date', 'type', 'city', 'state'],
                    filterable: ['id', 'name', 'date', 'type', 'city', 'state'],
                    filterByColumn: true,
                    debounce: 1000,
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                      'id': 'ID',
                      'name': 'Nome',
                      'date': 'Data',
                      'type': 'Tipo',
                      'city': 'Cidade',
                      'state': 'Estado',
                      'actions': 'Ações'
                    },
                    templates: {
                    },
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = [ ];

                        return this.$http.get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    }

                },
                endPoint: 'holidays/',

                dataForm: {}
            }
        },
        components: {
            BaseCrud
        },
        methods: {
            query: function (query) {
                let columns = {
                    id: 'id',
                    name: 'name',
                    date: 'date',
                    type: 'type',
                    city: 'city',
                    state: 'state'
                };
                let filters = '';
                $.each(query, function (index, value) {
                    filters += columns[index] + '=' + value + '&';
                });
                return filters;
            }
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Holidays/Crud.vue